import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';

export type Getters = {
  getContextoCalendario(state: State): State;
};

export const getters: GetterTree<State, RootState> & Getters = {
  getContextoCalendario: (state) => state,
};
